module.exports = __webpack_public_path__ + "static/content_2_4_eg-4349b67d739f0ce7f4bc33e9f00def29.png";